import { Col, Row } from 'antd';
import React from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';

import { primaryColor } from '../../constants/COLORS';
import { LOGO } from '../../constants/CONSTANTS';
import { URL_HOME } from '../../constants/URLS';

const Page404 = () => {
  return (
    <Wrapper>
      <Row style={{ textAlign: 'center' }}>
        <Link to={URL_HOME}>
          <Logo src={LOGO} />
        </Link>
      </Row>
      <Row>
        <Col span={24}>
          <div style={{ margin: '0 10% 0 20%' }}>
            <h1>Oops!</h1>
            <h2>We can't seem to find the page you're looking for.</h2>
            <h3>
              Error code: <span>404</span>
            </h3>
          </div>
        </Col>
      </Row>
    </Wrapper>
  );
};

const Wrapper = styled.div`
  h1 {
    font-size: 160px;
    font-weight: 600;
    color: #5b5a60;
  }

  h2 {
    margin-top: -60px;
    font-size: 36px;
    font-weight: 400;
    color: #5b5a60;
  }

  h3 {
    font-size: 18px;
    font-weight: 600;
    color: #5b5a60;
  }

  span {
    color: ${primaryColor};
  }
`;

const Logo = styled.img`
  width: 60px;
  height: 60px;
`;

export default Page404;
